import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import InfoIcon from "@mui/icons-material/Info";
import { useMutation } from "react-query";
import { useQueryClient } from "react-query";
import { REFERENCE_KEY } from "../../config/cacheKey";
import { CustomerInfo } from "../../models/loan.model";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function ModalVerify({
  openModel,
  customerInfo,
  handelDisplayFacility,
}: any) {
  const [open, setOpen] = React.useState<boolean>(openModel);
  const [info, setInfo] = React.useState<CustomerInfo>(customerInfo);
  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);
  React.useEffect(() => {
    setInfo(customerInfo);
  }, [customerInfo]);
  const QueryClient = useQueryClient();
  // const sendLoanActivationCodeToCustomerMutation = useMutation(
  //   sendLoanActivationCodeToCustomer,
  //   {
  //     onSuccess: (data: boolean) => {
  //       if (data) {
  //         handelDisplayFacility(true);
  //         handleClose();
  //       }
  //     },
  //   }
  // );
  const handleClose = () => setOpen(false);
  const handelVerify = () => {};
  const handelCancel = () => { 
    handleClose();
  };
  return (
    <div>
      <Modal
        keepMounted
        open={open}
        // onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{ borderRadius: "6px" }}
          className="ModalCmp textCenter"
        >
          <InfoIcon className="classIcons bluColor  textCenter marginLeft-10" />
          <Typography className="textCenter mTop30 mbottom20">
            تاییدیه اطلاعات
          </Typography>
          <Grid>
            <Typography className="justify ">
              <span className="subColor"> نام و نام خانوادگی : </span>
              <span className="colorDefaultFont"></span>
            </Typography>
            <br />
            <Typography className="justify ">
              <span className="subColor">کد ملی :</span>
            </Typography>
            <br />
            <Typography className="justify ">
              <span className="subColor"> شماره موبایل :</span>
            </Typography>
            <br />
            <Typography className="justify ">
              <span className="subColor"> تاریخ تولد :</span>
            </Typography>
            <br />
            <Typography className="justify ">
              <span className="subColor"> کد پستی :</span>
            </Typography>
            <br />
            {/* <Typography className="justify ">
              <span className="subColor">  مبلغ تسهیلات  :</span>
              <span className="colorDefaultFont">{(info?.).toLocaleString("fa")}</span>
            </Typography>
            <br /> */}
            <Typography className="justify ">
              <span className="subColor"> آدرس :</span>
            </Typography>
          </Grid>
          <Grid container spacing={2} columns={16} className="mTop20">
            <Grid item xs={8}>
              <Button
                onClick={handelVerify}
                fullWidth
                className="btnForm SuccessDefault"
              >
                تایید
              </Button>
            </Grid>
            <Grid item xs={8}>
              <Button
                onClick={handelCancel}
                fullWidth
                className="btnForm DangerDefault"
              >
                انصراف
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
